import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

import { Layout } from 'react-admin';
import Menu from './Menu';
import Error from './common/errors/Error';
import AppBar from './common/layout/AppBar';
import Sidebar from './common/layout/Sidebar';
import SpeedDial from './common/SpeedDial';

const AppLayout = props => (
    <Layout
        {...props}
        appBar={AppBar}
        menu={Menu}
        sidebar={Sidebar}
        error={Error}
    >
        <CssBaseline />
        {props.children}

        <SpeedDial />
    </Layout>
);

export default AppLayout;
